module.exports = __webpack_public_path__ + "static/media/IMG_6804.67810d34.JPG";